@if (mediaQueryService.breakpoints$ | async; as breakpoints) {
  <div [ngClass]="{ 'side-panel': sidePanel }">
    @if (!editMode) {
      <div class="address-details" data-test-id="address-edit-address-details-container">
        <div class="flex flex-between-center">
          <div class="address-label">Private address</div>
          @if (!readonly && sidePanel && canEdit) {
            @if (isEmpty) {
              <button
                (click)="activate()"
                class="small-button"
                color="primary"
                data-test-id="address-edit-address-details-sidepanel-add-button"
                mat-button
              >
                Add
              </button>
            }
            @if (!isEmpty) {
              <button
                (click)="activate()"
                class="small-button"
                color="primary"
                data-test-id="address-edit-address-details-sidepanel-edit-button"
                mat-button
              >
                Edit
              </button>
            }
          }
        </div>

        <div class="flex flex-between-start">
          <div class="address-value flex flex-col flex-start-start">
            @if (!!address.AddressLine1 || !!address.AddressLine2) {
              <div>
                @if (!!address.AddressLine1) {
                  <span class="line1 multiline" data-test-id="address-edit-address-line1-value">
                    {{ address.AddressLine1 }}
                  </span>
                }
                @if (!!address.AddressLine1 && !!address.AddressLine2) {
                  <span>&nbsp;</span>
                }
                @if (!!address.AddressLine2) {
                  <span class="line2 multiline" data-test-id="address-edit-address-line2-value">
                    {{ address.AddressLine2 }}
                  </span>
                }
              </div>
            }
            @if (!!address.CountryName || !!address.City || !!address.PostalCode) {
              <div>
                @if (!!address.PostalCode) {
                  <span class="zip multiline" data-test-id="address-edit-address-zip-value">
                    {{ address.PostalCode }}
                  </span>
                }
                @if (!!address.PostalCode && (!!address.City || !!address.CountryName)) {
                  <span>,</span>
                }
                @if (!!address.City) {
                  <span class="city multiline" data-test-id="address-edit-address-city-value">{{ address.City }}</span>
                }
                @if (!!address.City && !!address.CountryName) {
                  <span>,</span>
                }
                @if (!!address.CountryName) {
                  <span class="country" data-test-id="address-edit-address-country-value">
                    {{ address.CountryName }}
                  </span>
                }
              </div>
            }
          </div>
          @if (!readonly && !sidePanel && canEdit) {
            @if (isEmpty) {
              <button
                (click)="activate()"
                class="small-button action-btn"
                color="primary"
                data-test-id="address-edit-address-details-add-button"
                mat-button
              >
                Add
              </button>
            }
            @if (!isEmpty) {
              <button
                (click)="activate()"
                class="small-button action-btn"
                color="primary"
                data-test-id="address-edit-address-details-edit-button"
                mat-button
              >
                Edit
              </button>
            }
          }
        </div>
      </div>
    }
    @if (editMode) {
      <div class="address-edit-form-groups">
        <form
          [formGroup]="addressEditForm"
          [ngClass]="{ loading: loading }"
          (keydown)="keyListener($event)"
          (keypress)="keyListener($event)"
          (ngSubmit)="update()"
          class="edit-form"
          data-test-id="address-edit-form"
          name="addressEditForm"
          novalidate
        >
          <h4 class="font-bold">Edit private address</h4>
          <div class="content">
            <div class="ng-select-flex-content-wrapper">
              <ng-select
                [clearable]="false"
                [closeOnSelect]="true"
                [items]="countryList"
                [multiple]="false"
                [virtualScroll]="true"
                bindLabel="Name"
                data-test-id="address-edit-form-country-select"
                formControlName="country"
                placeholder="Select Country"
              ></ng-select>
              <label class="ng-select-label">Country</label>
            </div>
            <mat-form-field appearance="outline" floatLabel="always" subscriptSizing="dynamic">
              <mat-label>City</mat-label>
              <input
                autocomplete="address-level2"
                data-test-id="address-edit-form-city-input"
                formControlName="city"
                id="input-city"
                matInput
                maxlength="100"
                name="city"
                placeholder="City"
                type="text"
              />
            </mat-form-field>

            <mat-form-field appearance="outline" floatLabel="always" subscriptSizing="dynamic">
              <mat-label>Zip/Postal Code</mat-label>
              <input
                autocomplete="address-level2"
                data-test-id="address-edit-form-zip-input"
                formControlName="postalCode"
                id="input-postalCode"
                matInput
                maxlength="20"
                name="city"
                placeholder="Zip/Postal code"
                type="text"
              />
            </mat-form-field>

            <!-- address line 1 -->
            <mat-form-field appearance="outline" floatLabel="always" subscriptSizing="dynamic">
              <mat-label>Address line 1</mat-label>
              <input
                data-test-id="address-edit-form-addressLine1-input"
                formControlName="addressLine1"
                id="input-addressLine1"
                matInput
                maxlength="100"
                name="addressLine1"
                placeholder="Address line 1"
                type="text"
              />
            </mat-form-field>

            <!-- address line 2 -->
            <mat-form-field appearance="outline" floatLabel="always" subscriptSizing="dynamic">
              <mat-label>Address line 2</mat-label>
              <input
                data-test-id="address-edit-form-addressLine2-input"
                formControlName="addressLine2"
                id="input-addressLine2"
                matInput
                maxlength="100"
                name="addressLine2"
                placeholder="Address line 2"
                type="text"
              />
            </mat-form-field>
          </div>
          <div class="form-actions">
            <button
              [loading]="loading"
              class="small-button"
              color="primary"
              data-test-id="address-edit-form-save-button"
              mat-stroked-button
              type="submit"
            >
              {{
                breakpoints.ltMd ? COMMON_BUTTONS_TEXTS.SAVE_CHANGES_MOBILE : COMMON_BUTTONS_TEXTS.SAVE_CHANGES_DESKTOP
              }}
            </button>
            <button
              (click)="reset()"
              class="small-button cancel-button"
              color="primary"
              data-test-id="address-edit-form-discard-button"
              mat-button
              type="button"
            >
              {{
                breakpoints.ltMd
                  ? COMMON_BUTTONS_TEXTS.DISCARD_CHANGES_MOBILE
                  : COMMON_BUTTONS_TEXTS.DISCARD_CHANGES_DESKTOP
              }}
            </button>
          </div>
        </form>
      </div>
    }
  </div>
}
